import React, { useState, useEffect } from "react";
import MediaQuery from "react-responsive";
import KaitouAndHensachi from './KaitouAndHensachi.jsx';

// Xserverに設置したAPIのURL（※ご自身の実際のURLに書き換えてください）
const API_URL = "https://tosajuku.info/tsjk_webpage/reservation/api/get_schedule.php";

const PublicDeadlineContent = ({ isMobile }) => {
    const [schedules, setSchedules] = useState([]);
    const [loading, setLoading] = useState(true);

    // XserverのPHP APIからDBの日程データを取得
    useEffect(() => {
        const fetchSchedules = async () => {
            try {
                const response = await fetch(API_URL);
                const result = await response.json();
                if (result.status === "success") {
                    setSchedules(result.data);
                }
            } catch (error) {
                console.error("日程データの取得に失敗しました:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchSchedules();
    }, []);

    // 現在の時刻に基づいて対象の回を判定
    const getCurrentSchedule = () => {
        if (schedules.length === 0) return null;
        
        const now = new Date();

        // display_end_date (表示切替日時) より未来の最小の回を取得
        // MySQLのdatetime文字列(YYYY-MM-DD HH:mm:ss)はiOSのSafari等でパースエラーになるため、
        // YYYY/MM/DD HH:mm:ss に変換してDateオブジェクトにするのが安全です。
        return schedules.find(item => {
            const displayEndStr = item.display_end_date.replace(/-/g, '/');
            const displayEnd = new Date(displayEndStr);
            return now <= displayEnd;
        });
    };

    const currentSchedule = getCurrentSchedule();
    
    // スタイルクラスをモバイルかどうかで切り替え
    const headingClass = isMobile ? "font-weight-bold h4" : "font-weight-bold h1";

    // 読み込み中
    if (loading) {
        return <div className={headingClass}>読み込み中...</div>;
    }

    // 表示ロジックの判定
    const renderMessage = () => {
        if (!currentSchedule) {
            return <div className={headingClass}>今年度の試験はすべて終了しました。</div>;
        }

        const now = new Date();
        // 日付文字列を安全にパース
        const receptionStartStr = currentSchedule.reception_start_date ? currentSchedule.reception_start_date.replace(/-/g, '/') : null;
        const receptionEndStr = currentSchedule.reception_end_date.replace(/-/g, '/');
        const examDateStr = currentSchedule.exam_date.replace(/-/g, '/');

        const receptionStart = receptionStartStr ? new Date(receptionStartStr) : null;
        const receptionEnd = new Date(receptionEndStr);
        const examDate = new Date(examDateStr);

        // 1. 予約開始前
        if (receptionStart && now < receptionStart) {
            return <div className={headingClass}>第{currentSchedule.kai}回の受付は、現在準備中です。</div>;
        }

        // 2. 予約受付中
        if (now <= receptionEnd) {
            const month = examDate.getMonth() + 1;
            const day = examDate.getDate();
            return (
                <div className={headingClass}>
                    第{currentSchedule.kai}回 {month}月{day}日 予約受付中 
                </div>
            );
        }

        // 3. 予約受付終了
        return <div className={headingClass}>第{currentSchedule.kai}回の受付は終了いたしました。</div>;
    };

    return (
        <div>
            <a href="#process" style={{ textDecoration: 'none', color: 'inherit' }}>
                {renderMessage()}
            </a>
            {/* モバイル版のみ表示していたコンポーネントがある場合 */}
            {/* {isMobile && <KaitouAndHensachi />} */}
            {/* <KaitouAndHensachi /> */}
            <KaitouAndHensachi schedules={schedules} />
        </div>
    );
};

const PublicDeadline = () => {
    return (
        <>
            <MediaQuery query="(max-width: 768px)">
                <PublicDeadlineContent isMobile={true} />
            </MediaQuery>

            <MediaQuery query="(min-width: 769px)">
                <PublicDeadlineContent isMobile={false} />
            </MediaQuery>
        </>
    );
};

export default PublicDeadline;